/// <reference path="../../../../../typings/index.d.ts" />
/// <reference path="../../../components/baseClasses/dataMaintenanceSectionBase.ts" />

module Meevo.Plugins.PackageTypes{
    "use strict";

    export class NotificationsSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<Model.PackageTypeNotificationOverride> {
        private modalService: Meevo.Components.Modal.IModalService;


        constructor(sectionId: number, displayNameContentKey: string, template: string, isPrimarySection: boolean,
            handlesOwnCrud: boolean, baseEndpoint: string, sectionEndpoint: string,
            loggingService: Meevo.Components.Logging.ILoggingService,
            dataService: Meevo.Components.BaseClasses.IDataService,
            identityService: Meevo.Components.Common.IIdentityService,
            noun: Meevo.Model.NounEnum,
            modalService: Meevo.Components.Modal.IModalService,
            sectionSecurityKey?: string) {

            super(sectionId, displayNameContentKey, template, isPrimarySection, handlesOwnCrud, baseEndpoint, sectionEndpoint, loggingService, dataService, identityService, noun, null, sectionSecurityKey);
            this.modalService = modalService;
        }
        
        resetSendBcc(index: number) {
            if (Model.Guard.isNothing(this.model.templates[index].templateDataDetail))
                this.model.templates[index].sendBcc = false;
        }

    }
}